import { PlanetLite } from '@apeiron/planet'
import { Box, styled } from '@mui/material'
import { SectionContent } from '@src/components/planet/detail/SectionContent'
import PlanetCard from '@src/components/planet/share/planetCard/PlanetCard'
import React from 'react'

const StyledSectionContent = styled(SectionContent)`
  width: 100%;
`

const PlanetListContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: space-evenly;
`

const PlanetTitle = styled(Box)`
  font-size: 14px;
  margin-bottom: 2px;
`

const StyledPlanetCard = styled(PlanetCard)`
  ${props => props.theme.breakpoints.up('res1280')} {
    width: 220px;
  }
  ${props => props.theme.breakpoints.down('res1280')} {
    width: 165px;

    // override planet card info header display when width < 1280
    .Custom-Info-Header {
      top: 2%;
    }
    .Custom-Id {
      font-size: 10px;
      line-height: 10px;
      margin-bottom: unset;
    }
    .Custom-Name {
      font-size: 12px;
      line-height: 12px;
    }
    .Custom-Info-Text {
      font-size: 10px;
      line-height: 10px;
    }
  }
`

export const PlanetListSection: React.FC<PlanetListSectionProps> = props => {
  const { className, renderTitle, renderPlanetUrl, onPlanetClick, planets } =
    props

  return (
    <StyledSectionContent className={className}>
      <PlanetListContainer>
        {planets.map((planet, i) => {
          return (
            <Box key={planet.planetID}>
              {renderTitle && (
                <PlanetTitle>{renderTitle(planet, i)}</PlanetTitle>
              )}
              <StyledPlanetCard
                planet={planet}
                renderUrl={renderPlanetUrl}
                onClick={onPlanetClick}
              />
            </Box>
          )
        })}
      </PlanetListContainer>
    </StyledSectionContent>
  )
}

export type PlanetListSectionProps = {
  className?: string
  planets: PlanetLite[]
  renderTitle?: (planet: PlanetLite, index: number) => React.ReactNode
  renderPlanetUrl?: (planet: PlanetLite) => string
  onPlanetClick?: (planet: PlanetLite) => void
}
